import { Form, Select, theme, Typography } from "antd";
import React from "react";

import {
  ClearIcon,
  FacetOptionBadge,
  FacetOptionLabel,
  FacetOptionRow,
  FacetSelectWrapper,
  StyledArrowDown,
} from "./styled";
import { FacetProps } from "./types";

import { ResponsiveSelect } from "~/Atom/ResponsiveSelect";

export const Facet: React.FC<FacetProps> = ({
  facetData,
  label,
  handleChange,
  value,
  resetLabel,
  hideValueInLabel,
  returnValueKey,
  disabled = false,
}) => {
  const { token } = theme.useToken();

  const [open, setOpen] = React.useState(false);

  return (
    <Form.Item
      {...(label ? { label: <strong>{label}</strong> } : {})}
      colon={false}
    >
      <FacetSelectWrapper $token={token} $hasValue={!!value}>
        <ResponsiveSelect
          className="facet-responsive-select"
          onChange={handleChange}
          value={value}
          showSearch={true}
          onDropdownVisibleChange={setOpen}
          mobileOptions={[
            { label: resetLabel || "Show all", value: "" },
          ].concat(
            facetData?.values.map((opt) => ({
              label: `${opt.label} (${opt.value})`,
              value: opt[returnValueKey || "label"],
            })) || []
          )}
          allowClear={{
            clearIcon: <ClearIcon size={24} />,
          }}
          suffixIcon={<StyledArrowDown open={open} />}
          disabled={disabled} 
        >
          {resetLabel && (
            <Select.Option name="clear" value="">
              <Typography.Text
                type="secondary"
                style={{
                  fontSize: "15px",
                  color: "#24242D",
                  fontWeight: 400,
                  lineHeight: "22px",
                }}
              >
                {resetLabel}
              </Typography.Text>
            </Select.Option>
          )}
          {facetData?.values.map((opt, idx) => (
            <Select.Option
              key={idx}
              name={opt.label}
              value={opt[returnValueKey || "label"]}
            >
              {hideValueInLabel ? (
                opt.label
              ) : (
                <FacetOptionRow>
                  <FacetOptionLabel className="facet-option-label">
                    {opt.label}
                  </FacetOptionLabel>
                  <FacetOptionBadge
                    size="small"
                    count={opt.value}
                    overflowCount={9999999}
                    color={token.colorText}
                  />
                </FacetOptionRow>
              )}
            </Select.Option>
          ))}
        </ResponsiveSelect>
      </FacetSelectWrapper>
    </Form.Item>
  );
};
